let accessRedirectPending = false;
let accessRedirectSourcePath: string | undefined;
let resolvedPathname: string | undefined;
let noticeSourcePath: string | undefined;
let noticeAwaitingDestination = false;
let resolvedAccessRedirectNotice:
    | { message: string; destination: string; sourcePath: string | undefined }
    | undefined;

/** Tracks the last route that finished loading, rather than a route still pending. */
export function setResolvedAccessRedirectPathname(pathname: string | undefined) {
    resolvedPathname = pathname;
}

export function getResolvedAccessRedirectPathname() {
    return resolvedPathname;
}

/** Marks an access failure so the `/` fallback can show its notice once. */
export function markAccessRedirectPending(pathname = resolvedPathname): boolean {
    // Several queries can fail together; keep the route that started the redirect.
    if (accessRedirectPending) return false;

    accessRedirectPending = true;
    accessRedirectSourcePath = pathname;
    return true;
}

/** Consumes the notice, suppressing it when the fallback is already the current page. */
export function takeAccessRedirectPending(destination?: string): boolean {
    const samePage = accessRedirectSourcePath && accessRedirectSourcePath === destination;
    const shouldShow = accessRedirectPending && !samePage;

    noticeSourcePath = shouldShow ? accessRedirectSourcePath : undefined;
    noticeAwaitingDestination = shouldShow;
    accessRedirectPending = false;
    accessRedirectSourcePath = undefined;
    return shouldShow;
}

/** Defers a redirect toast until the router confirms that its destination loaded. */
export function deferAccessRedirectNotice(message: string, destination: string) {
    if (!noticeAwaitingDestination) return;

    resolvedAccessRedirectNotice = {
        message,
        destination,
        sourcePath: noticeSourcePath,
    };
    noticeSourcePath = undefined;
    noticeAwaitingDestination = false;
}

/** Returns a redirect toast only when the resolved route is its intended destination. */
export function takeResolvedAccessRedirectNotice(pathname: string): string | undefined {
    const notice = resolvedAccessRedirectNotice;
    if (!notice) return undefined;

    resolvedAccessRedirectNotice = undefined;

    if (notice.destination !== pathname || notice.sourcePath === pathname) {
        return undefined;
    }

    return notice.message;
}
